import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ShoppingBag } from "lucide-react";
import { getAuthErrorMessage } from "../LoginForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const token = () => localStorage.getItem("comp_token");
const STATUS = {
  order_received: ["Rendelés felvéve", "bg-sky-100 text-sky-900 ring-sky-300"],
  pending: ["Rendelés felvéve", "bg-sky-100 text-sky-900 ring-sky-300"],
  payment_pending: ["Fizetés folyamatban", "bg-yellow-100 text-yellow-900 ring-yellow-300"],
  paid: ["Fizetett", "bg-emerald-100 text-emerald-900 ring-emerald-300"],
  payment_failed: ["Fizetés sikertelen", "bg-red-100 text-red-800 ring-red-300"],
  preparing: ["Rendelés készülőben", "bg-indigo-100 text-indigo-900 ring-indigo-300"],
  ready_pickup: ["Átvehető", "bg-purple-100 text-purple-900 ring-purple-300"],
  completed: ["Átvette", "bg-emerald-100 text-emerald-900 ring-emerald-300"],
  cancelled: ["Törölve", "bg-red-100 text-red-800 ring-red-300"],
};
const ft = (n) => `${Number(n || 0).toLocaleString("hu-HU")} Ft`;
const fdate = (iso) => (iso ? new Date(iso).toLocaleString("hu-HU", { dateStyle: "medium", timeStyle: "short" }) : "");

export function RendelesekTab() {
  const [orders, setOrders] = useState(null);
  useEffect(() => {
    axios.get(`${API}/ugyfelkapu/orders`, { params: { token: token() } }).then((r) => setOrders(r.data || [])).catch((e) => { toast.error(getAuthErrorMessage(e)); setOrders([]); });
  }, []);
  const card = "rounded-3xl bg-white p-5 sm:p-7 shadow-[0_10px_40px_rgba(15,23,42,0.08)] ring-1 ring-slate-100";
  return (
    <div className="mx-auto w-full max-w-3xl space-y-4" data-testid="rendelesek-tab">
      <h2 className="flex items-center gap-2 text-lg font-bold text-slate-900"><ShoppingBag size={20} className="text-slate-700" /> Rendeléseim</h2>
      {!orders ? <p className="py-8 text-center text-slate-700">Betöltés...</p> : orders.length === 0 ? (
        <div className={`${card} text-center`}><p className="text-sm font-medium text-slate-800" data-testid="orders-empty">Még nincs rendelésed.</p></div>
      ) : orders.map((o) => {
        const [label, cls] = STATUS[o.status] || [o.status, "bg-slate-100 text-slate-800 ring-slate-300"];
        return (
          <article key={o.id} className={card} data-testid={`order-${o.order_number}`}>
            <div className="mb-3 flex flex-wrap items-start justify-between gap-2">
              <div>
                <p className="font-mono text-sm font-bold tracking-wide text-slate-900" data-testid={`order-number-${o.order_number}`}>{o.order_number}</p>
                <p className="text-xs text-slate-700">{fdate(o.created_at)}</p>
              </div>
              <span className={`rounded-full px-3 py-1 text-xs font-bold ring-1 ${cls}`} data-testid={`order-status-${o.order_number}`}>{label}</span>
            </div>
            <ul className="divide-y divide-slate-100 rounded-2xl bg-slate-50 px-4" data-testid={`order-items-${o.order_number}`}>
              {(o.items || []).map((it, i) => (
                <li key={i} className="flex items-center justify-between gap-3 py-2.5 text-sm">
                  <span className="min-w-0 text-slate-900"><span className="font-medium">{it.quantity} × {it.product_name}</span>
                    {it.variation_selections && Object.keys(it.variation_selections).length > 0 && <span className="ml-1 text-xs text-slate-700">({Object.values(it.variation_selections).join(", ")})</span>}
                    {it.custom_name && <span className="ml-1 text-xs text-slate-700">„{it.custom_name}”</span>}</span>
                  <span className="shrink-0 text-slate-800">{ft(it.price * it.quantity)}</span>
                </li>
              ))}
            </ul>
            <div className="mt-3 flex items-center justify-between text-sm">
              <span className="text-slate-700">{o.discount_amount ? `Kedvezmény: −${ft(o.discount_amount)}${o.coupon_code ? ` (${o.coupon_code})` : ""}` : ""}</span>
              <span className="text-base font-bold text-slate-900" data-testid={`order-total-${o.order_number}`}>Végösszeg: {ft(o.total_amount || o.total_price)}</span>
            </div>
          </article>
        );
      })}
    </div>
  );
}

export default RendelesekTab;
